module.exports = __webpack_public_path__ + "static/media/Abhinav_Kurule.7cb84e25.jpg";